import { Building, Business, Floor, TypeOfJob } from '@admin/models';
import {
  BuildingService,
  BusinessService,
  FloorService,
  WorkplaceTypeService,
} from '@admin/services';
import { DashboardService } from '@admin/services/dashboard.service';
import { AsyncPipe } from '@angular/common';
import {
  Component,
  DestroyRef,
  OnInit,
  ViewChild,
  inject,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardContent, MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import {
  MatFormField,
  MatFormFieldModule,
  MatLabel,
} from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import {
  MatOption,
  MatSelect,
  MatSelectModule,
} from '@angular/material/select';
import { LogoService, ToastAlertService } from '@core/services';
import { ChartConfiguration, ChartData, ChartType } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';
import { Observable } from 'rxjs';
import { Cookies } from 'typescript-cookie';
import { HeatMapV2Component } from '../heat-map';
import { ButtonComponent } from '@shared/components';
import html2canvas from 'html2canvas';
import * as jspdf from 'jspdf';
import { HeatMapImageComponent } from '../heat-map-image';
import { selectLogo } from '@store/selectors';
import { Store } from '@ngrx/store';

interface ReportGraphic {
  NAME: string;
  ReservationCount: number;
}
@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [
    MatCardModule,
    MatCardContent,
    MatIconModule,
    MatDividerModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatMenuModule,
    BaseChartDirective,
    MatSelectModule,
    MatFormField,
    MatLabel,
    MatSelect,
    MatOption,
    MatAutocompleteModule,
    AsyncPipe,
    FormsModule,
    HeatMapV2Component,
    ButtonComponent,
    HeatMapImageComponent,
  ],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css',
})
export class DashboardComponent implements OnInit {
  order: string[] = ['En espera', 'En curso', 'Eliminado', 'Culminado'];
  private readonly store = inject(Store);
  public readonly logo = this.store.selectSignal(selectLogo);
  private logoService = inject(LogoService);
  @ViewChild(MatMenuTrigger) menu!: MatMenuTrigger;
  #DashboardService = inject(DashboardService);
  workplacetype = inject(WorkplaceTypeService);
  alertService = inject(ToastAlertService);
  cookieRole = Cookies.get('role');
  TotalBusiness = signal<number>(0);
  TotalBusinessNoFilters = signal<number>(0);
  TotalUsers = signal<number>(0);
  TotalReservations = signal<number>(0);
  labelReservationsCount = signal<string>('Reservas completadas último mes');
  businessStateLabel = signal<string>('Activas');
  TotalReservationsActive = signal<number>(0);
  building = inject(BuildingService);
  edificios: Building[] = [];
  floor = inject(FloorService);
  private destroyRef = inject(DestroyRef);
  private businessServices = inject(BusinessService);

  puestos: TypeOfJob[] = [];
  private TypeWorkplace = signal(0);
  floors: Floor[] = [];
  public bussines: Business[] = [];
  public bussinesForLogo: Business[] = [];

  //selects
  businessId: number = -1;
  buildingId: number = -1;
  floorId: number = -1;
  workPlaceId: number = -1;
  filter: string = 'lastMonth';
  public selectValueCompani = -1; //VALOR SELECCIONADO DE LA COMPANI O EMPRESA
  public valorRango = '';

  rangeFilter = signal([
    { value: 'nextWeek', name: 'Próxima semana' },
    { value: 'nextMonth', name: 'Próximo mes' },
    { value: 'lastWeek', name: 'Última semana' },
    { value: 'lastMonth', name: 'Último mes' },
    { value: 'lastThreeMonths', name: 'Últimos 3 meses' },
    { value: 'lastYear', name: 'Último año' },
  ]);

  onRangeChange(event: any) {
    const selectedValue = event.value;
    const selectedRange = this.rangeFilter().find(
      range => range.value === selectedValue
    );

    if (selectedRange && selectedRange.name) {
      this.valorRango = selectedRange.name;
    } else {
      this.valorRango = 'Último mes';
    }

    console.log('Valor seleccionado:', selectedValue);
    console.log('Nombre del rango seleccionado:', this.valorRango);

    this.getReservationsGraphic();
  }

  filteredOptions: Observable<Business[]> = new Observable<Business[]>(
    observer => {
      observer.next([]);
    }
  );
  myControl = new FormControl('');

  public barChartType: ChartType = 'doughnut';

  public barChartData: ChartData<'doughnut'> = {
    labels: ['ESPERA', 'CURSO', 'ELIMINADO', 'CULMINADO'],
    datasets: [{ data: [0, 0, 0, 0], label: 'Series A' }],
  };

  public barChartOptions: ChartConfiguration['options'] = {
    responsive: true,
    plugins: {
      legend: {
        display: true, // Mostrar leyenda
        position: 'bottom', // Posición de la leyenda
        labels: {
          generateLabels: (chart: any) => {
            const data = chart.data;
            if (data.labels && data.datasets) {
              return data.labels.map((label: string, i: number) => {
                const value = data.datasets[0].data[i]; // Obtener el valor correspondiente
                return {
                  text: `${label}: ${value}`, // Concatenar la etiqueta y el valor
                  fillStyle: data.datasets[0].backgroundColor[i], // Color de fondo para la leyenda
                  hidden: !chart.getDataVisibility(i),
                  index: i,
                };
              });
            }
            return [];
          },
        },
      },
      tooltip: {
        enabled: true, // Puedes dejar los tooltips habilitados si quieres mostrar información adicional al pasar el ratón
      },
    },
  };

  // Método para actualizar datos de ejemplo
  updateChartData(newData: number[]): void {
    this.barChartData.datasets[0].data = newData;
    this.barChartData = { ...this.barChartData }; // Clona el objeto para detectar el cambio
  }
  ngOnInit(): void {
    if (this.cookieRole === 'SYSADMIN' || this.cookieRole === 'ACCESOS') {
      this.getBusinessCount(1);
    }
    this.getTotalUsers();
    this.getReservationsCount('lastMonth');
    this.getReservationsActive('lastThreeMonths');

    //GRAFICA 2
    this.getBusiness();
    const business = Cookies.get('bussinesId')?.toString();

    if (business !== null) {
      this.ObtenerEdificios(parseInt(business!));
      this.ObtenerPuestos(parseInt(business!));
    }

    this.getReservationsGraphic();
  }

  statesGraphic: number[] = [];
  getReservationsGraphic() {
    const business = Cookies.get('bussinesId')?.toString();
    const formData: any = {
      filter: this.filter,
      businessId: this.businessId !== -1 ? this.businessId : undefined,
      workPlaceId: this.workPlaceId !== -1 ? this.workPlaceId : undefined,
      buildingId: this.buildingId !== -1 ? this.buildingId : undefined,
      floorId: this.floorId !== -1 ? this.floorId : undefined,
    };
    if (this.cookieRole !== 'SYSADMIN' && this.cookieRole !== 'ACCESOS') {
      if (business !== null) {
        formData.businessId = business;
      }
    }
    if (
      !isNaN(this.businessId) &&
      this.businessId !== -1 &&
      this.businessId !== null
    ) {
      formData.businessId = this.businessId;
    } else {
      delete formData.businessId;
    }

    if (formData.workPlaceId === -1) {
      delete formData.workPlaceId;
    }
    if (formData.buildingId === -1) {
      delete formData.buildingId;
    }
    if (formData.floorId === -1) {
      delete formData.floorId;
    }
    console.log('formData', formData);
    const order = ['EN ESPERA', 'EN CURSO', 'ELIMINADO', 'CULMINADO'];
    this.#DashboardService.getReservationsGraaphic(formData).subscribe({
      next: (request: any) => {
        if (request.code === 10000 || request.code === 40009) {
          const reservationCounts = request.reply.data.map(
            (reservation: ReportGraphic) => reservation.ReservationCount
          );
          console.log('DATAAA', reservationCounts);

          // Ordena los datos según el orden definido
          const sortedData = order.map(label => {
            const index = request.reply.data.findIndex(
              (reservation: ReportGraphic) => reservation.NAME === label
            );
            return reservationCounts[index];
          });
          // Almacenar sortedData en sortedDataArray
          this.statesGraphic = sortedData;

          this.updateChartData(sortedData);
          console.log('datos de la grafica', sortedData);
        }
      },
    });
  }

  selectFloor(floor: number): void {
    this.floorId = floor;
    console.log('flooor id', this.floorId);
    this.getReservationsGraphic();
  }
  private getBusiness() {
    this.businessServices
      .getBusiness()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (request: any) => {
          if (request.code === 10000 || request.code === 40009) {
            this.bussines = request.reply;
            this.bussinesForLogo = request.reply;
            console.log('negocios', this.bussines);
          }
        },
      });
  }
  chargueFloorByBuilding(buldingid: number) {
    this.floorId = -1;
    this.floors = [];
    this.floor
      .getFloorsByBuilding(buldingid)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: resp => {
          if (resp.code === 10000) {
            this.floors = resp.reply || [];
          } else {
            this.alertService.error(resp.detail);
          }
        },
      });
    this.getReservationsGraphic();
  }
  ObtenerEdificios(businessId: number) {
    this.loadLogo();

    this.edificios = [];
    this.puestos = [];
    this.floors = [];
    this.buildingId = -1;
    this.floorId = -1;
    this.workPlaceId = -1;
    this.businessId = businessId;
    console.log('obtener edificio', this.businessId);
    this.getReservationsGraphic();
    this.building.getBuildings(businessId).subscribe(response => {
      if (response.status) {
        this.edificios = response.reply;
      } else {
        console.error('Error al obtener los los edificios:', response.detail);
      }
    });
    this.ObtenerPuestos(this.businessId);
  }
  ObtenerPuestos(businessId: number) {
    this.businessId = businessId;
    this.workplacetype.getWorkplaces(businessId).subscribe(response => {
      if (response.status) {
        this.puestos = response.reply;
      } else {
        this.alertService.error(response.detail);
      }
    });
  }
  selectType(type: number): void {
    this.TypeWorkplace.set(type);
    this.getReservationsGraphic();
  }
  downloadExcel(): void {
    const business = Cookies.get('bussinesId')?.toString();

    let formData: any = {
      filter: this.filter,
      businessId: this.businessId !== -1 ? this.businessId : undefined,
      workPlaceId: this.workPlaceId !== -1 ? this.workPlaceId : undefined,
      buildingId: this.buildingId !== -1 ? this.buildingId : undefined,
      floorId: this.floorId !== -1 ? this.floorId : undefined,
    };
    if (this.cookieRole !== 'SYSADMIN' && this.cookieRole !== 'ACCESOS') {
      if (business !== null) {
        formData.businessId = business;
      }
    }
    if (
      !isNaN(this.businessId) &&
      this.businessId !== -1 &&
      this.businessId !== null
    ) {
      formData.businessId = this.businessId;
    } else {
      delete formData.businessId;
    }

    if (formData.workPlaceId === -1) {
      delete formData.workPlaceId;
    }
    if (formData.buildingId === -1) {
      delete formData.buildingId;
    }
    if (formData.floorId === -1) {
      delete formData.floorId;
    }
    console.log(formData);
    this.#DashboardService
      .getReservationReservariosCountxcsv(formData)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: Blob) => {
        console.log('data', data);
        if (data.type == 'application/json') {
          this.alertService.warning('No hay datos para descargar.');
        } else {
          const file = new Blob([data], { type: 'application/pdf' });
          const url = window.URL.createObjectURL(file);
          const link = document.createElement('a');
          link.href = url;
          link.download = 'reporte_reservas.xlsx';
          link.click();
          window.URL.revokeObjectURL(url);
        }
      });
  }
  getBusinessCount(state: number) {
    const stateLabel = state === 1 ? 'activas' : 'suspendidas';
    this.businessStateLabel.set(stateLabel);

    this.#DashboardService
      .getBusinessCount({ accountStatusId: state })
      .subscribe({
        next: reply => {
          if (reply.code === 10000) {
            this.TotalBusiness.set(reply.reply.count);
            this.TotalBusinessNoFilters.set(reply.reply.totalBusiness);
            console.log(
              'TotalBusiness',
              this.TotalBusiness.set(reply.reply.count)
            );
            console.log(
              'TotalBusinessNoFilters',
              this.TotalBusinessNoFilters.set(reply.reply.totalBusiness)
            );
          } else {
            this.TotalBusiness.set(0);
            this.TotalBusinessNoFilters.set(0);
          }
        },
      });
  }
  getTotalUsers() {
    if (this.cookieRole !== 'SYSADMIN' && this.cookieRole !== 'ACCESOS') {
      const business = Cookies.get('bussinesId');
      this.#DashboardService
        .getWorkerCount({ businessId: business })
        .subscribe({
          next: reply => {
            if (reply.code === 10000) {
              this.TotalUsers.set(reply.reply.count);
            } else {
              this.TotalUsers.set(0);
            }
          },
        });
    } else {
      this.#DashboardService.getWorkerCount({}).subscribe({
        next: reply => {
          if (reply.code === 10000) {
            if (reply.code === 10000) {
              this.TotalUsers.set(reply.reply.count);
            } else {
              this.TotalUsers.set(0);
            }
          }
        },
      });
    }
  }
  getReservationsCount(filter: string) {
    const business = Cookies.get('bussinesId');

    if (this.cookieRole !== 'SYSADMIN' && this.cookieRole !== 'ACCESOS') {
      const data = {
        businessId: business,
        filter: filter,
      };
      this.#DashboardService.getReservationsCount(data).subscribe({
        next: reply => {
          if (reply.code === 10000) {
            this.TotalReservations.set(reply.reply.count);
          } else {
            this.TotalReservations.set(0);
          }
        },
      });
    } else {
      const data = {
        filter: filter,
      };
      this.#DashboardService.getReservationsCount(data).subscribe({
        next: reply => {
          if (reply.code === 10000) {
            if (reply.code === 10000) {
              this.TotalReservations.set(reply.reply.count);
            } else {
              this.TotalReservations.set(0);
            }
          }
        },
      });
    }
    switch (filter) {
      case 'lastWeek':
        this.labelReservationsCount.set('Reservas completadas última semana');
        break;
      case 'lastMonth':
        this.labelReservationsCount.set('Reservas completadas último mes');
        break;
      case 'lastThreeMonths':
        this.labelReservationsCount.set('Reservas completadas últimos 3 meses');
        break;
      case 'lastYear':
        this.labelReservationsCount.set('Reservas completadas último año');
        break;
      default:
        this.labelReservationsCount.set('Reservas completadas');
    }
  }
  getReservationsActive(filter: string) {
    const business = Cookies.get('bussinesId');

    if (this.cookieRole !== 'SYSADMIN' && this.cookieRole !== 'ACCESOS') {
      const data = {
        businessId: business,
        filter: filter,
      };
      this.#DashboardService.getReservationsActiveCount(data).subscribe({
        next: reply => {
          if (reply.code === 10000) {
            this.TotalReservationsActive.set(reply.reply.count);
          } else {
            this.TotalReservationsActive.set(0);
          }
        },
      });
    } else {
      const data = {
        filter: filter,
      };
      this.#DashboardService.getReservationsActiveCount(data).subscribe({
        next: reply => {
          if (reply.code === 10000) {
            if (reply.code === 10000) {
              this.TotalReservationsActive.set(reply.reply.count);
            } else {
              this.TotalReservationsActive.set(0);
            }
          }
        },
      });
    }
  }

  imgsysadmin = '';
  idlogoSeleccionado: number = -1;
  loadLogo() {
    this.imgsysadmin = '';
    this.idlogoSeleccionado = -1;
    if (this.cookieRole === 'SYSADMIN' || this.cookieRole === 'ACCESOS') {
      for (const business of this.bussinesForLogo) {
        if (business.idBusiness === this.selectValueCompani) {
          this.idlogoSeleccionado = business.idLogo || 0;
        }
      }
    } else if (this.cookieRole === 'ADMINISTRADOR') {
      const logo = Cookies.get('logo');
      this.idlogoSeleccionado = logo ? Number(logo) : 0;
    }

    // Obtener el logo correspondiente
    if (this.idlogoSeleccionado > 0) {
      this.logoService.getOneLogo(this.idlogoSeleccionado).subscribe({
        next: ({ reply }) => {
          this.imgsysadmin = reply.value;
          console.log('imagen en base 64', this.imgsysadmin);
        },
      });
    } else {
      const imgElement = new Image();
      imgElement.onload = () => {
        // Convertir la imagen alternativa a base64 cuando se genere el PDF
        this.imgsysadmin = imgElement.src;
        console.log('imagen alternativa cargada', this.imgsysadmin);
      };
      imgElement.src = '../../../../../assets/icon.png';
    }
  }

  downloadPDF() {
    const canvasElement = document.getElementById(
      'reservations-canvas'
    ) as HTMLCanvasElement;

    // Verificar si hay datos seleccionados
    if (this.statesGraphic.length === 0) {
      alert('Por favor, seleccione datos antes de generar el PDF.');
      return;
    }

    if (!canvasElement) {
      console.error('No hay datos estadísticos');
      return;
    }

    // Capturar el contenido del canvas como una imagen
    html2canvas(canvasElement).then(reservationCanvas => {
      const reservationImgData = reservationCanvas.toDataURL('image/png');

      // Configurar el documento PDF
      const pdf = new jspdf.jsPDF('p', 'mm', 'letter');

      // Definir márgenes y dimensiones de página
      const leftMargin = 25; // Margen izquierdo en mm
      const rightMargin = 10; // Margen derecho en mm
      const pageWidth = pdf.internal.pageSize.getWidth(); // Ancho de la página en mm
      const usableWidth = pageWidth - leftMargin - rightMargin;

      let logoWidth = 30; // Ancho del logo en mm
      let logoHeight = 30; // Alto del logo en mm

      // Verificar si es la imagen alternativa
      const isAlternativeImage = this.imgsysadmin.includes('assets/icon.png');
      console.log('isAlternativeImage:', isAlternativeImage);

      if (isAlternativeImage) {
        logoWidth = 40; // Ancho del logo alternativo en mm
        logoHeight = 30; // Alto del logo alternativo en mm
      }

      // Agregar logo al PDF si está disponible
      if (this.imgsysadmin) {
        const logoX = leftMargin; // Posición X del logo (a la izquierda)
        const logoY = 10; // Posición Y del logo

        pdf.addImage(
          this.imgsysadmin,
          'PNG',
          logoX,
          logoY,
          logoWidth,
          logoHeight
        );
      }

      // Agregar título del reporte
      const titleText = 'Reporte de Reservas';
      const titleFontSize = 18; // Tamaño de fuente del título
      const titleTextWidth =
        (pdf.getStringUnitWidth(titleText) * titleFontSize) /
        pdf.internal.scaleFactor;
      const titleX = (pageWidth - titleTextWidth) / 2; // Centrado horizontalmente
      const titleY = 40; // Posición Y del título

      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(titleFontSize);
      pdf.text(titleText, titleX, titleY + 5);

      let valorRangoText = '';
      if (this.valorRango) {
        valorRangoText = `Reporte ${this.valorRango}`;
      } else {
        valorRangoText = 'Reporte último mes';
      }
      const valorRangoFontSize = 14; // Tamaño de fuente para el valor de rango

      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(valorRangoFontSize);
      const valorRangoX = leftMargin; // Margen izquierdo
      pdf.text(valorRangoText, valorRangoX, titleY + 15); // y si no colocale Reporte Último mes si no trae valor
      // Agregar texto estático "Resumen"
      const staticText = 'Resumen';
      const staticTextFontSize = 14;
      const middleX = pageWidth / 2;

      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(staticTextFontSize);
      pdf.text(staticText, middleX + 25, titleY + 40);

      // Agregar gráfico y datos
      const graphX = leftMargin;
      const graphY = titleY + 30;
      const contentHeight = reservationCanvas.height;
      const contentWidth = reservationCanvas.width;
      const halfWidth = usableWidth / 2;
      const halfHeight = (halfWidth * contentHeight) / contentWidth;

      pdf.addImage(
        reservationImgData,
        'PNG',
        graphX,
        graphY,
        halfWidth,
        halfHeight
      );

      // Agregar datos de gráfico
      let textY = graphY + halfHeight + 10;
      let total = 0;

      this.statesGraphic.forEach((data, index) => {
        total += data;
        pdf.setFontSize(12);
        pdf.text(`${this.order[index]}: ${data}`, middleX + 25, textY - 80);
        textY += 10;
      });

      // Agregar total
      pdf.setFontSize(12);
      pdf.text(`Total: ${total}`, middleX + 25, textY - 65);

      // Agregar fecha y usuario al pie del PDF
      const currentDate = new Date();
      const formattedDate = `${currentDate.toLocaleDateString()} ${currentDate.toLocaleTimeString()}`;
      const footerY = pdf.internal.pageSize.height - 10;
      pdf.setTextColor(0, 0, 255);
      pdf.setFont('helvetica');
      pdf.setFontSize(10);
      pdf.text(formattedDate, leftMargin, footerY);

      const user = Cookies.get('username');
      pdf.text(`Usuario: ${user}`, leftMargin, footerY + 5);

      pdf.save('Reporte de reservas.pdf');
    });
  }
}
